import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import { BaseSearchFilterDto, type CustomMetadataSearchFilterElementDto } from '@/api';
import SearchFilterTreeview from '@/components/SearchFilterTreeview.vue';
/**
 *
 * CustomMetadataFilters
 * Wraps SearchFilterTreeview for Custom Metadata,
 * Proxies the selected values list and dispatches amongst the filters
 *
 */

interface CustomMetadataFiltersProps {
  filters: BaseSearchFilterDto[];
  value: string[];
}

type CustomMetadataFiltersEmits = {
  (event: 'input', items: string[]): void;
}

const ITEMS_SEARCH_THRESHOLD = 10

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomMetadataFilters',
  props: {
  filters: { default: () => [] },
  value: { default: () => [] }
},
  emits: ["input"],
  setup(__props, { emit: emits }) {




// Threshold above which the search bar will be displayed

let localValue = _ref<string[]>([]);

/**
 * Emits selected values:
 * Proxies the selected values, distinct by filter
 * @param values
 */
 const emitValues = (values: string[], filter: BaseSearchFilterDto) => {
  // Remove all the local values that match this filter children
  const filteredLocalValue = localValue.value.filter((v) => !filter.children?.some((child) => (child as CustomMetadataSearchFilterElementDto).id === v));
  // Add the new values
  filteredLocalValue.push(...values);
  localValue.value = filteredLocalValue;
  emits('input', localValue.value);
};

/**
 * Filter the values so that we provide only values that are children of the filter
 * @param value
 * @param filter
 */
const valueByFilterChildren = (value: string[], filter: BaseSearchFilterDto): string[] => {
  if (!filter.children) return [];
  return value.filter((v) => filter.children?.some((child) => (child as CustomMetadataSearchFilterElementDto).id === v));
};


return { __sfc: true,ITEMS_SEARCH_THRESHOLD, emits, localValue, emitValues, valueByFilterChildren, _ref, BaseSearchFilterDto, SearchFilterTreeview }
}

})